import React, { Fragment } from 'react'
import '../styles.scss'
import { Tabs, TabsProps } from 'antd';
import SalesAndService from './SalesAndService';
import SupportHistory from './SupportHistory';
import SurveyInformation from './SurveyInformation';
import MarketingNew from './MarketingNew';

const InteractionHistory = ({stData = {} as any, stChange = (data: any) => {}}) => {

    const onChange = (key: string) => {
        // setIsTab(Number(key));
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css font-light text-lg'>Chăm sóc bán hàng, dịch vụ</span>,
            children: <SalesAndService stData={stData} stChange={(data) => stChange(data)}  />,
        },
        {
            key: '2',
            label: <span className='custom-page-css font-light text-lg'>Lịch sử hỗ trợ, khiếu nại</span>,
            children: <SupportHistory />,
        },
        {
            key: '3',
            label: <span className='custom-page-css font-light text-lg'>Thông tin khảo sát</span>,
            children: <SurveyInformation />,
        },
        {
            key: '4',
            label: <span className='custom-page-css font-light text-lg'>Marketing</span>,
            children: <MarketingNew />,
        },
    ];


    return (
        <Fragment>
            <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 ">

                {/* <div className="custom-page-css w-full flex items-center gap-3">
                    <div className="custom-page-css py-5 flex flex-1 flex-column items-center justify-center gap-1 rounded border">
                        <span className='custom-page-css text-lg font-regular text-475467'>Ngày tương tác gần nhất</span>
                        <div className="custom-page-css flex items-center w-full  ">
                            <span className='custom-page-css flex flex-1 items-center justify-center text-2xl font-light font-medium px-1 text-344054'>3 ngày</span>
                        </div>
                    </div>
                    <div className="custom-page-css py-5 flex flex-1 flex-column items-center justify-center gap-1 rounded border">
                        <span className='custom-page-css text-lg font-regular text-475467'>Mức độ hài lòng</span>
                        <div className="custom-page-css flex items-center w-full justify-center ">
                            <span className='custom-page-css flex items-center justify-center text-2xl font-light font-medium px-8 text-344054 border-r'>100% </span>
                            <span className='custom-page-css flex items-center justify-center text-2xl font-light font-medium px-8 text-344054'>5 lần</span>
                        </div>
                    </div>
                </div> */}
                <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />
                </div>
            </div>
        </Fragment>
    )
}
export default InteractionHistory
